import React, { Component } from 'react';
import * as mat from 'material-ui';
import Logo from '../images/Logoaa.jpg'
import './style.css'
import FaUser from 'react-icons/lib/fa/user'
import FaSearch from 'react-icons/lib/fa/search'
import FaQuestionCircle from 'react-icons/lib/fa/question-circle'
import FaSignOut from 'react-icons/lib/fa/sign-out';
import MdMenu from 'react-icons/lib/md/menu'
import FaAngleDown from 'react-icons/lib/fa/angle-down';
import MdChat from 'react-icons/lib/md/chat'
import { browserHistory } from 'react-router';
import { UserLogOut, userDetailEdit } from '../../action/authAction'
import { connect } from 'react-redux';

const styles = {
    logo: {
        width: 90,
        height: 45,
        marginLeft: '24%',
    },
}
class HOMENAVAFTERAUTH extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            menu: false,
        };
    }

    Support() {
        browserHistory.push('/feedback');
    }
    SupportCell() {
        browserHistory.push('/feedback');
        this.setState({ menu: false })
    }
    FindMage() {
        browserHistory.push('/find-mage');
    }
    FindMageCell() {
        browserHistory.push('/find-mage');
        this.setState({ menu: false })
    }
    FAQ() {
        browserHistory.push('/faq')
    }
    FAQCELL() {
        browserHistory.push('/faq')
        this.setState({ menu: false })
    }
    SearchMageCell() {
        browserHistory.push('/search-mage');
        // this.props.AllQuiz()
        this.setState({ menu: false })
    }
    Forget = () => {
        browserHistory.push('/forget-password')
        this.setState({
            open: false,
            menu: false 
        });
    };
    handleMenuClick = (event) => {
        // This prevents ghost click.
        event.preventDefault();

        this.setState({
            open: true,
            anchorEl: event.currentTarget,
        });
    };
    handleMenuClickCell = (event) => {
        // This prevents ghost click.
        event.preventDefault();

        this.setState({
            open: true,
            anchorEl: event.currentTarget,
        });
    };

    handleRequestClose = () => {
        this.setState({
            open: false,
        });
    };

    handleChange = (event, index, value) => this.setState({ value });

    OpenMenu = () => this.setState({ menu: !this.state.menu });

    handleClose = () => this.setState({ menu: false });

    editProfile() {
        this.props.userDetailEdit();
        this.setState({
            open: false,
            menu: false
        });
    }
    SignOut() {
        this.props.UserLogOut()
    }
    // myMageCell() {
    //     // this.props.MyMage()
    //     this.setState({ menu: false })
    //     this.props.UserSharedData(this.props.AllQuizs, this.props.UsersList)
    //     // console.log(this.props.AllQuizs);
    // }
    myResult() {
        browserHistory.push('/my-result')
        this.setState({
            open: false,
            menu: false
        });
    }
    // ResultsCell() {
    //     // this.props.GetAllQuizs();
    //     this.setState({ menu: false })
    // }
    // SendEmail() {
    //     console.log("Send email")
    // }
    render() {
        const {
            auth,
        } = this.props;
        return (
            <div>
                {/* NAV BAR */}
                <div>
                    <mat.AppBar
                        iconElementLeft={
                            <div>
                                <div id='Options'>
                                    <img onClick={() => { browserHistory.push('/home') }} style={styles.logo} src={Logo} alt='Logo' />
                                </div>
                                <div className='MenuOptions'>
                                    <MdMenu
                                        onClick={this.OpenMenu}
                                        style={{ color: 'white', fontSize: '3em' }}
                                    />
                                </div>
                            </div>
                        }
                        iconElementRight={
                            <div id='Options' style={{ marginTop: '1%' }}>
                                <mat.FlatButton
                                    label='My Mage'
                                    onClick={() => { browserHistory.push('/home') }}
                                    labelStyle={{ color: '#ffffff' }}
                                    icon={<FaUser style={{ color: 'white', fontSize: 18, marginTop: -3 }} />}
                                />
                                &nbsp;
                                &nbsp;
                                <mat.FlatButton
                                    onClick={this.FindMage.bind(this)}
                                    label='Find Mage'
                                    labelStyle={{ color: '#ffffff' }}
                                    icon={<FaSearch style={{ color: 'white', fontSize: 18, marginTop: -3 }} />}
                                />
                                &nbsp;
                                &nbsp;
                                <mat.FlatButton
                                    onClick={this.FAQ.bind(this)}
                                    label='FAQ'
                                    labelStyle={{ color: '#ffffff' }}
                                    icon={<FaQuestionCircle style={{ color: 'white', fontSize: 18, marginTop: -3 }} />}
                                />
                                &nbsp;
                                &nbsp;
                                <mat.FlatButton
                                    onClick={this.Support.bind(this)}
                                    label='Support'
                                    labelStyle={{ color: '#ffffff' }}
                                    icon={<MdChat style={{ color: 'white', fontSize: 18, marginTop: -3 }} />}
                                />
                                &nbsp;
                                &nbsp;
                                <mat.FlatButton
                                    onClick={this.handleMenuClick}
                                    label={<span>{auth.userName} <FaAngleDown style={{ color: 'white', fontSize: '1.5em', fontWeight: 'bold' }} /></span>}
                                    labelStyle={{ color: '#ffffff' }}
                                    icon={
                                        (auth.profile === 'https') ? (
                                            <mat.Avatar
                                                backgroundColor={'#2196f3'}
                                                style={{ left: 8, top: -5, color: '#ffffff', fontSize: 30 }}
                                                size={35}
                                            >
                                                {auth.userName.charAt(0)}
                                            </mat.Avatar>
                                        ) : (
                                                <mat.Avatar size={35} src={auth.profile} />
                                            )
                                    }
                                />
                                <mat.Popover
                                    open={this.state.open}
                                    anchorEl={this.state.anchorEl}
                                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                                    targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                                    onRequestClose={this.handleRequestClose}
                                >
                                    <mat.Menu>
                                        <mat.MenuItem onClick={this.editProfile.bind(this)} primaryText="Edit profile" />
                                        <mat.MenuItem onClick={this.myResult.bind(this)} primaryText="My Result" />
                                        <mat.MenuItem onClick={this.Forget.bind(this)} primaryText="Change password" />
                                        <mat.Divider />
                                        <mat.MenuItem
                                            onClick={this.SignOut.bind(this)}
                                            primaryText='Log Out'
                                            leftIcon={<FaSignOut />}
                                        />
                                    </mat.Menu>
                                </mat.Popover>
                            </div>
                        }
                        style={{ backgroundColor: '#2196f3' }}
                        zDepth={1}
                    />
                </div>
                {/* NAV BAR End*/}

                <div>
                    <mat.Drawer
                        docked={false}
                        width={250}
                        open={this.state.menu}
                        onRequestChange={(menu) => this.setState({ menu })}
                    >
                        <mat.AppBar
                            title={
                                <img src={Logo}
                                    style={{ width: 95, height: 45, }}
                                    alt='logo'
                                    onClick={() => { browserHistory.push('/home') }}
                                />
                            }
                            showMenuIconButton={false}
                            style={{ backgroundColor: '#2196f3' }}
                        />
                        <mat.MenuItem onClick={() => { browserHistory.push('/home'); this.setState({menu: false}) }} primaryText="My Mage" leftIcon={<FaUser />} />
                        <mat.MenuItem onClick={this.FindMageCell.bind(this)} primaryText="Find Mage" leftIcon={<FaSearch />} />
                        <mat.MenuItem onClick={this.FAQCELL.bind(this)} primaryText="FAQ" leftIcon={<FaQuestionCircle />} />
                        <mat.MenuItem onClick={this.SupportCell.bind(this)} primaryText="Support" leftIcon={<MdChat />} />
                        <mat.MenuItem primaryText={auth.userName} onClick={this.handleMenuClickCell} rightIcon={<FaAngleDown />} leftIcon={<mat.Avatar size={35} src={auth.profile} />} />
                        <mat.Divider />
                        <mat.FlatButton style={{ marginLeft: '62%' }} label="Close" onClick={this.handleClose} />
                    </mat.Drawer>
                </div>
                <div>
                    {this.props.children}
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        auth: state.authReducers.userDetails,
        // UsersList: state.SahreReducers.AllUsers,
        // AllQuizs: state.QuizReducders.AllQuiz
        // sent: state.AdminReducer.send
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        UserLogOut: () => {
            dispatch(UserLogOut());
        },
        userDetailEdit: () => {
            dispatch(userDetailEdit())
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(HOMENAVAFTERAUTH);
// export default HOMENAVAFTERAUTH;


// WEBPACK FOOTER //
// ./src/component/home/homeNav.jsx